import "./Home.module.css";
import MainNavigationHeader from "@/reusable_sections/Header";
import FlagshipSmartphoneShowcase from "./sections/FlagshipSmartphoneShowcase";
import DeviceEcosystemCategories from "./sections/DeviceEcosystemCategories";
import TrendingTechDeals from "./sections/TrendingTechDeals";
import TradeInRepairSpotlight from "./sections/TradeInRepairSpotlight";
import JoinTheTechwireCommunity from "./sections/JoinTheTechwireCommunity";
import SiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigationHeader />
      <FlagshipSmartphoneShowcase />
      <DeviceEcosystemCategories />
      <TrendingTechDeals />
      <TradeInRepairSpotlight />
      <JoinTheTechwireCommunity />
      <SiteFooter />
    </div>;
}